import { render } from "./SeparatorTabletFormComponentDetails.vue?vue&type=template&id=65e6f8f6"
import script from "./SeparatorTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./SeparatorTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__